module.exports = __webpack_public_path__ + "static/img/img5.09b0a088.png";